import assembleURLHash from '../Base/route/assembleURLHash';

export default function toList(data) {
    const view = this.getViewName();
    if (view == 'list') {
        this.reload();
    } else {
        location.href = assembleURLHash('list', data);
    }
}
